import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { AccountService } from '../_services/account.service';

import { ParameterData } from '../_helpers/index';
import { Router } from '@angular/router';
import { Status } from '../_enums/invoice';
import { DataService } from '../_helpers/dataservice.service'
import { Account } from '../_models';
import { currencysymbolPrefix } from '../_enums/debtordocumenttype';
import { bankName, accountType } from '../_enums/account';

@Component({
    selector: 'accountcreate',
    templateUrl: './accountcreate.component.html',
    styleUrls: ['../../assets/css/customer-list-table.css']
})

export class AccountCreateComponent implements OnInit, OnDestroy {

    public customer_public_id: string;
    public customer_Account_public_id: string;

    public accountForm: FormGroup;

    ddlbalanceCurrencySymbol: any[];
    ddlbankType: any[];
    ddlbankName: any[];

    public isalertVisiable: any;
    public auth0Profile: any;



    /** This is Constructor function which is used to initialize the class variables and objects; 
     */
    constructor
        (
            private router: Router, private formBuilder: FormBuilder, private _fbaccount: FormBuilder
            , private parameterData: ParameterData, private dataService: DataService
            , private status: Status
            , private datePipe: DatePipe
            , private accountService: AccountService
            , private _currencysymbolPrefix: currencysymbolPrefix
            , private _bankName: bankName
            , private _accountType: accountType
        ) {

        this.InitialSetup();


        this.ddlbalanceCurrencySymbol = _currencysymbolPrefix.currencyPrefix;
        this.ddlbankType = _accountType._accountType;
        this.ddlbankName = _bankName._bankName;


    }//end 








    /** This is ngOnInit function called after initialising the component; 
   */
    ngOnInit() {




        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
        }


        const toSelect_BalanceCurrencySymbol = this.ddlbalanceCurrencySymbol.find(c => c.value == 'S/.');
        this.accountForm.get('balance.currency').setValue(toSelect_BalanceCurrencySymbol.value);

        const toSelect_BankType = this.ddlbankType.find(c => c.value == 'PSP');
        this.accountForm.get('type').setValue(toSelect_BankType.value);

        const toSelect_BankName = this.ddlbankName.find(c => c.name == 'BCP');
        this.accountForm.get('bank.name').setValue(toSelect_BankName.name);

    }//end



    ngOnDestroy() {

    }//end



    /*
          This function is used to initialize form controls
  */
    InitialSetup() {

        this.accountForm = this._fbaccount.group({
            customer: this._fbaccount.group({
                public_id: new FormControl("0")
            }),
            holder: this._fbaccount.group({
                public_id: new FormControl("")
            }),
            account_number: new FormControl(""),
            name: new FormControl("", Validators.required),
            description: new FormControl(""),

            balance: this._fbaccount.group({
                currency: new FormControl(""),
                value: new FormControl("")
            }),

            type: new FormControl(""),
            bank: this._fbaccount.group({
                name: new FormControl(""),
                id: new FormControl(0)
            })
        });
    }//end initial setup




    /** This is onsubmit function called for all Invoice Data Save/Update Component; 
     */
    onsubmit({ value }: { value: Account }) {

        value.holder.public_id = this.customer_public_id;
        value.customer.public_id = this.customer_public_id;

        if (value.balance.currency == 'S/.') {
            value.balance.currency = 'PEN';
            value.balance.value = Number(value.balance.value);
        }

        if (value.balance.currency == 'US$') {
            value.balance.currency = 'USD';
            value.balance.value = Number(value.balance.value);
        }




        this.accountService.createAccount(value)
            .subscribe((result) => {
                this.isalertVisiable = true;
            }, error => {
                console.log('Failed while trying to create the Account Details.' + error);
            });



    }//end submit






}//end class


